/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_Speed_LabelInputs */

const en_tts_tool_speed_label = /** @type {(inputs: Tts_Tool_Speed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speed`)
};

const es_tts_tool_speed_label = /** @type {(inputs: Tts_Tool_Speed_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad`)
};

/**
* | output |
* | --- |
* | "Speed" |
*
* @param {Tts_Tool_Speed_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_speed_label = /** @type {((inputs?: Tts_Tool_Speed_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Speed_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_speed_label(inputs)
	return en_tts_tool_speed_label(inputs)
});